import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Icon, Radio, Tooltip, Divider } from 'antd';
import { Beneficiary } from '../../../../models';
import { connect } from 'react-redux';
import { alertify, handleApiExceptions } from '../../../../app_methods';


let BeneficiaryForm = (props) => {
    const { form, beneficiary } = props;
    const { getFieldDecorator } = form;
    const validations = Beneficiary.validations;
    const userPaymentModes = props?.current_user?.payment_modes; 

    const [isVerifying, setIsVerifying] = useState(false);
    const [beneficiaryTypeForm, setBeneficiaryTypeForm] = useState({})

    const currentBeneficiaryType = (props) =>{
        if (userPaymentModes?.some(m => ["IMPS", "NEFT", "RTGS"].includes(m))){
            setBeneficiaryTypeForm({beneficiary_type: "bank_account" })
        } 
        else if (userPaymentModes?.includes("UPI")){
            setBeneficiaryTypeForm({beneficiary_type: "upi" })
        }
    }

    useEffect(() => {
        currentBeneficiaryType(props)
    }, [])

    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (err) return;
            props.onSubmit(form.getFieldsValue());
        });
    }

    const verifyUPIHandle = () => {
        if (!form.getFieldValue("upi_handle")) return;
        setIsVerifying(true);
        Beneficiary.verify_vpa({ vpa: form.getFieldValue("upi_handle") }).then(response => {
            setIsVerifying(false);
            if (response.success) {
                let beneficiary_name = "";
                if (response.data.status == "valid") beneficiary_name = response.data.account_holder_name;
                else if (["invalid", "failure"].includes(response.data.status)) alertify("Oops!", "Entered UPI Handle is invalid.", "error");
                form.setFieldsValue({ "beneficiary_name": beneficiary_name });
            }
            else {
                alertify("Oops!", response.message || "Something went wrong.", "error");
            }
        }).catch(error => {
            setIsVerifying(false);
            handleApiExceptions(error);
        })
    };

    const verifyBankAccount = () => {
        if (!form.getFieldValue("account_number") || !form.getFieldValue("ifsc")) return;
        setIsVerifying(true);
        Beneficiary.verify_bank_account({
            account_no: form.getFieldValue("account_number"),
            ifsc: form.getFieldValue("ifsc")
        }).then(response => {
            setIsVerifying(false);
            if (response.success) {
                let beneficiary_name = "";
                if (response.data.status != "valid") handleApiExceptions("Bank account details are invalid.");
                else beneficiary_name = response.data.account_holder_name;
                form.setFieldsValue({ "beneficiary_name": beneficiary_name });
            }
            else {
                alertify("Oops!", response.message || "Something went wrong.", "error");
            }
        }).catch(error => {
            setIsVerifying(false);
            handleApiExceptions(error);
        })
    };

    const renderVAExtra = () => {
        return (
            props.current_user.euv ?
                <Button type="link" size="small" loading={isVerifying} onClick={verifyUPIHandle}>Verify</Button> : null
        )
    };

    const renderBankAccountDetailsForm = () => {
        return (
            <>
                <Form.Item label="Account Number">
                    {getFieldDecorator("account_number", {
                        initialValue: beneficiary.account_number,
                        rules: validations.account_number
                    })(<Input autoComplete='off' prefix={<Icon type="bank" />} />)}
                </Form.Item>

                <Form.Item className="mb-0" label="Account IFSC Code">
                    {getFieldDecorator("ifsc", {
                        initialValue: beneficiary.account_ifsc,
                        rules: validations.ifsc
                    })(<Input autoComplete='off' prefix={<Icon type="bank" />} />)}
                </Form.Item>
                
                {
                    props.current_user.ebav ?
                        <>
                            <div className="mt-1 d-flex justify-content-end">
                                <Button className="px-0" type="link" onClick={verifyBankAccount} loading={isVerifying}>Verify Bank Account</Button>
                            </div>
                            <Divider style={{ marginTop: 10, marginBottom: 10, background: "#dddddd" }} />
                        </> : null
                }
            </>
        )
    };

    const renderUpiDetailsForm = () => {
        return (
            <Form.Item label="UPI Handle">
                {getFieldDecorator("upi_handle", {
                    initialValue: beneficiary.upi_handle,
                    rules: validations.upi_handle
                })(<Input autoComplete='off' id="upi_handle" prefix={<Icon type="qrcode" />} addonAfter={renderVAExtra()} />)}
            </Form.Item>
        )
    };


    return (
        <Form onSubmit={onSubmit}>
            {getFieldDecorator("id", {
                initialValue: beneficiary.uuid,
                rules: validations.uuid
            })(<Input autoComplete='off' hidden />)}

            {getFieldDecorator("contact_id", {
                initialValue: props.contact.uuid,
                rules: validations.contact_id
            })(<Input autoComplete='off' hidden />)}

            <div className="mb-4">
                {getFieldDecorator("beneficiary_type", {
                    initialValue: beneficiaryTypeForm?.beneficiary_type,
                    rules: validations.beneficiary_type
                })(
                    <Radio.Group>
                        {
                            props.current_user.payment_modes.some(m => ["IMPS", "NEFT", "RTGS"].includes(m)) ?
                                <Radio.Button value="bank_account">Bank Account</Radio.Button> : null
                        }
                        {
                            props.current_user.payment_modes.includes("UPI") ?
                                <Radio.Button value="upi">UPI Handle</Radio.Button> : null
                        }
                    </Radio.Group>
                )}
            </div>

            {form.getFieldValue("beneficiary_type") == "bank_account" ? renderBankAccountDetailsForm() : renderUpiDetailsForm()}

            <Form.Item label="Beneficiary Name">
                {getFieldDecorator("beneficiary_name", {
                    initialValue: beneficiary.beneficiary_name,
                    rules: validations.beneficiary_name
                })(<Input autoComplete='off' prefix={<Icon type="user" />} />)}
            </Form.Item>

            <div className="w-100 d-flex justify-content-end mt-4">
                <Button type="primary" htmlType="submit" loading={props.loading}>Create</Button>
            </div>
        </Form>
    )
};

BeneficiaryForm.defaultProps = {
    beneficiary: {},
    contact: {}
}

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

BeneficiaryForm = Form.create()(BeneficiaryForm);

export default connect(mapStateToProps)(BeneficiaryForm);